module.exports = __webpack_public_path__ + "img/shoot_00004.e19fe672.png";